import {
    marketPropertyJsonDefaultData,
    marketPropertyJsonList,
    propertyJsonDefaultData,
    propertyJsonList,
} from 'src/utils/property-json';
import { AWS_URL, OTHER_WEB, OTHER_WEB_ADMIN, PLATFORM, PROD_OR_DEV } from './api';
import { S3_PUBLIC } from 'config';

const cumaAIButtonConfig = {
    cuma: 'CUMA_ADMIN',
    market: 'CM_ADMIN',
    ru: 'RU_ADMIN',
    jikgu: 'RIKGU_ADMIN',
};

const paymentMethodTypeCardConfig = {
    cuma: '오과페이(카드)',
    market: '쿠마페이(카드)',
    ru: '리유페이(카드)',
    jikgu: '직구에어페이(카드)',
};

const paymentMethodTypeBankTransferConfig = {
    cuma: '오과페이(계좌이체)',
    market: '쿠마페이(계좌이체)',
    ru: '리유페이(계좌이체)',
    jikgu: '직구에어페이(계좌이체)',
};

const propertyJsonConfig = {
    cuma: [
        {
            key: '배송',
            value: `평일기준 2~3일 소요되는 점 참고 부탁드립니다.
상품 특성상 ±10% 오차가 있을 수 있습니다.
상품 특성상 사진과 다를 수 있습니다.
상품의 품질이 기준에 못미치거나 수량이 부족할 경우 배송지연 또는 주문취소 될 수 있습니다.`,
        },
        {
            key: '상품 정보고시',
            value: '',
        },
        { key: '용량 · 중량', value: '' },
        { key: '원산지', value: '' },
        { key: '소비자상담번호', value: '주식회사 퍼스트엔터테인먼트 ｜ 1644-3353' },
        {
            key: '반품',
            value: `상품 특성상 변심반품은 불가합니다.
손상, 훼손이 아닌 개인 입맛차이에 따른 반품은 불가합니다.`,
        },
    ],
    market: [
        {
            key: `제품명`,
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            value: ``,
        },
        {
            key: `배송`,
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `용량 및 사이즈`,
            value: ``,
        },
        {
            key: `생산자 / 수입자`,
            value: ``,
        },
        {
            key: `제조년원 / 소비기한`,
            value: ``,
        },
        {
            key: `제조국`,
            value: ``,
        },
        {
            key: `취급시 주의사항`,
            value: ``,
        },
        {
            key: `품질 보증기준`,
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            value: `주식회사 한국유기농 ｜ 062-450-7700`,
        },
    ],
    ru: [
        {
            key: `제품명`,
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            value: ``,
        },
        {
            key: `배송`,
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `용량 및 사이즈`,
            value: ``,
        },
        {
            key: `생산자 / 수입자`,
            value: ``,
        },
        {
            key: `제조년원 / 소비기한`,
            value: ``,
        },
        {
            key: `제조국`,
            value: ``,
        },
        {
            key: `취급시 주의사항`,
            value: ``,
        },
        {
            key: `품질 보증기준`,
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            value: `리유코스메틱 | 062-450-7700`,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            value: `리유코스메틱 | 062-450-7700`,
        },
    ],
    jikgu: [
        {
            key: `제품명`,
            value: ``,
        },
        {
            key: `변심반품 택배비`,
            value: ``,
        },
        {
            key: `배송`,
            value: `주문 및 결제 완료 후 3~7일 이내 출고됩니다.`,
        },
        {
            key: `용량 및 사이즈`,
            value: ``,
        },
        {
            key: `생산자 / 수입자`,
            value: ``,
        },
        {
            key: `제조년원 / 소비기한`,
            value: ``,
        },
        {
            key: `제조국`,
            value: ``,
        },
        {
            key: `취급시 주의사항`,
            value: ``,
        },
        {
            key: `품질 보증기준`,
            value: ``,
        },
        {
            key: `A/S 책임자와 전화번호`,
            value: ``,
        },
        {
            key: `소비자 상담 관련 전화번호`,
            value: `리유코스메틱 ｜ 062-450-7700`,
        },
    ],
};

const distributorConfig = {
    cuma: { id: 101, name: '퍼스트 식품' },
    market: { id: 101, name: '퍼스트 식품' },
    ru: { id: 4, name: '한국유기농' },
    jikgu: { id: 1, name: '직구에어' },
};

const faviconConfig = {
    cuma: '/favicon_today.png',
    market: '/favicon_market.png',
    ru: '/favicon_ru.svg',
    jikgu: '/favicon_jikgu.svg',
};

const titleConfig = {
    cuma: 'CUMA ADMIN',
    market: 'CUMA MARKET ADMIN',
    ru: 'REU ADMIN',
    jikgu: 'JIKGU AIR ADMIN',
};

const bottomMenuListButtonsNameConfig = {
    cuma: [
        { name: '오늘과일 홈페이지', URL: PROD_OR_DEV },
        { name: '쿠마마켓 어드민', URL: OTHER_WEB_ADMIN[0] },
        { name: '쿠마마켓 홈페이지', URL: OTHER_WEB[0] },
        { name: '리유코스메틱 어드민', URL: OTHER_WEB_ADMIN[1] },
        { name: '리유코스메틱 홈페이지', URL: OTHER_WEB[1] },
        { name: '직구에어 어드민', URL: OTHER_WEB_ADMIN[2] },
        { name: '직구에어 홈페이지', URL: OTHER_WEB[2] },
        { name: '캐시 제거', URL: AWS_URL },
    ],
    market: [
        { name: '쿠마마켓 홈페이지', URL: PROD_OR_DEV },
        { name: '오늘과일 어드민', URL: OTHER_WEB_ADMIN[0] },
        { name: '오늘과일 홈페이지', URL: OTHER_WEB[0] },
        { name: '리유코스메틱 어드민', URL: OTHER_WEB_ADMIN[1] },
        { name: '리유코스메틱 홈페이지', URL: OTHER_WEB[1] },
        { name: '직구에어 어드민', URL: OTHER_WEB_ADMIN[2] },
        { name: '직구에어 홈페이지', URL: OTHER_WEB[2] },
    ],
    ru: [
        { name: '리유코스메틱 홈페이지', URL: PROD_OR_DEV },
        { name: '오늘과일 어드민', URL: OTHER_WEB_ADMIN[0] },
        { name: '오늘과일 홈페이지', URL: OTHER_WEB[0] },
        { name: '쿠마마켓 어드민', URL: OTHER_WEB_ADMIN[1] },
        { name: '쿠마마켓 홈페이지', URL: OTHER_WEB[1] },
        { name: '직구에어 어드민', URL: OTHER_WEB_ADMIN[2] },
        { name: '직구에어 홈페이지', URL: OTHER_WEB[2] },
    ],
    jikgu: [
        { name: '직구에어 홈페이지', URL: PROD_OR_DEV },
        { name: '오늘과일 어드민', URL: OTHER_WEB_ADMIN[0] },
        { name: '오늘과일 홈페이지', URL: OTHER_WEB[0] },
        { name: '쿠마마켓 어드민', URL: OTHER_WEB_ADMIN[1] },
        { name: '쿠마마켓 홈페이지', URL: OTHER_WEB[1] },
        { name: '리유코스메틱 어드민', URL: OTHER_WEB_ADMIN[2] },
        { name: '리유코스메틱 홈페이지', URL: OTHER_WEB[2] },
    ],
};

const ivsPlatformIconConfig = {
    cuma: `${S3_PUBLIC}/icon/ic_ivs_platform_cuma.svg`,
    market: `${S3_PUBLIC}/icon/ic_ivs_platform_cuma_market.svg`,
    ru: `${S3_PUBLIC}/icon/ic_ivs_platform_ru.svg`,
};

const platformIconConfig = {
    cuma: `${S3_PUBLIC}/icon/platform_cuma.svg`,
    market: `${S3_PUBLIC}/icon/platform_market.svg`,
    ru: `${S3_PUBLIC}/icon/platform_ru.svg`,
};

const initialPropertyJsonConfig = {
    cuma: propertyJsonList.map((item: { name: string; key: string }) => {
        return { id: 0, name: item.name, value: item.key };
    }),
    market: marketPropertyJsonList.map((item: { name: string; key: string }) => {
        return { id: 0, name: item.name, value: item.key };
    }),
    ru: marketPropertyJsonList.map((item: { name: string; key: string }) => {
        return { id: 0, name: item.name, value: item.key };
    }),
    jikgu: marketPropertyJsonList.map((item: { name: string; key: string }) => {
        return { id: 0, name: item.name, value: item.key };
    }),
};

const defaultPropertyJsonDefaultConfig = {
    cuma: propertyJsonDefaultData,
    market: marketPropertyJsonDefaultData,
    ru: marketPropertyJsonDefaultData,
    jikgu: marketPropertyJsonDefaultData,
};

const adminLogoConfig = {
    cuma: `/admin_logo.svg`,
    market: `/market_admin_logo.svg`,
    ru: `/ru_logo.svg`,
    jikgu: `/jikgu_logo.svg`,
};

class ConfigByPlatform {
    private static instance: ConfigByPlatform;
    private platform: string;

    private constructor() {
        // PLATFORM 키워드에 대한 검증
        // PLATFORM -> ENVIROMENT.split('_')[0]
        // PLATFORM = 'cuma-market' 이면 'cuma-market이 들어감'
        if (!['cuma', 'market', 'ru', 'jikgu'].includes(PLATFORM)) {
            throw new Error(`Unknown environment: ${PLATFORM}`);
        }
        this.platform = PLATFORM;
    }

    static getInstance(): ConfigByPlatform {
        if (!ConfigByPlatform.instance) {
            ConfigByPlatform.instance = new ConfigByPlatform();
        }
        return ConfigByPlatform.instance;
    }

    // 정의된 객체와 PLATFORM 키워드 대입 검증
    private getConfigValue(config, configName) {
        if (config[this.platform]) {
            return config[this.platform];
        }
        throw new Error(`잘못된 key 값입니다: ${configName}`);
    }

    get cumaAIButtonString() {
        return this.getConfigValue(cumaAIButtonConfig, 'cumaAIButtonConfig');
    }

    get paymentMethodTypeCard() {
        return this.getConfigValue(paymentMethodTypeCardConfig, 'paymentMethodTypeCardConfig');
    }

    get paymentMethodTypeBankTransfer() {
        return this.getConfigValue(paymentMethodTypeBankTransferConfig, 'paymentMethodTypeBankTransferConfig');
    }

    get distributor() {
        return this.getConfigValue(distributorConfig, 'distributorConfig');
    }

    get favicon() {
        return this.getConfigValue(faviconConfig, 'faviconConfig');
    }

    get title() {
        return this.getConfigValue(titleConfig, 'titleConfig');
    }

    get bottomMenuListButtons() {
        return this.getConfigValue(bottomMenuListButtonsNameConfig, 'bottomMenuListButtonsNameConfig');
    }

    get propertyJson() {
        return this.getConfigValue(propertyJsonConfig, 'propertyJsonConfig');
    }

    get initialPropertyJson() {
        return this.getConfigValue(initialPropertyJsonConfig, 'initialPropertyJsonConfig');
    }

    get defaultPropertyJson() {
        return this.getConfigValue(defaultPropertyJsonDefaultConfig, 'defaultPropertyJsonDefaultConfig');
    }
    get adminLogo() {
        return this.getConfigValue(adminLogoConfig, 'adminLogoConfig');
    }
    get ivsPlatformIcon() {
        return this.getConfigValue(ivsPlatformIconConfig, 'ivsPlatformIconConfig');
    }

    get platformIcon() {
        return this.getConfigValue(platformIconConfig, 'platformIconConfig');
    }
}

export const configByPlatform = ConfigByPlatform.getInstance();
